
async function addUrl() {
  return new Promise(resolve => {
    const image = new Image()
    image.onerror = () => resolve(false)
    image.onload = () => resolve(image.width === 1)
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA='
  }).catch(() => false)
}

export default {

  async init(Vue) {
    const isSupportWebp = await addUrl()
    // 挂载在 vue.prototype 下，表示是否支持 webp
    Vue.prototype.DidaIsSupportWebp = isSupportWebp
    Vue.directive('webpBg', {
      bind: el => {
        if (isSupportWebp) {
          try {
            el.classList.add("webp")
          } catch (error) {
            el.className += ' webp'
          }
        }
      }
    })
    Vue.component('webp-img', {
      data(){
        return {
          addNum : false
        }
      },
      props: {
        src: {
          type: String,
          required: true
        },
        alt: {
          type: String
        }
      },
      computed: {
        setWebpUrl: function() {
          if(isSupportWebp && this.src){
            let url = 'https://web-static.didachuxing.com/pics/' + this.src.split('pics/').pop()
            return url.replace(/\.(jpg|png|gif)/,'.webp')
          }
          return this.src
        }
      },
      
      render: function(createElement) {
        return createElement(
          'img', // 标签名称
          {
            attrs: {
              src: this.setWebpUrl,
              alt: this.alt || ''
            },
            on: {
              click: (el) => {
                this.$emit('click', el)
              },
              error: el => {
                if(!this.addNum){
                  el.target.src = this.src
                  this.addNum = true
                }
              },
              load: (el)=>{
                this.$emit('load', el)
              }
            }
          }
        )
      }
    })
    return isSupportWebp
  }
}